import PropTypes from 'prop-types';
import TicketsMultiFiltro from './TicketsMultiFiltro';

// Filtro multi-selección por agente asignado. Comparte popover con el de
// estado (TicketsMultiFiltro) y adapta el catálogo de usuarios del módulo
// ({ id, nombre, email }) al formato de opciones. Los usuarios sin `nombre`
// caen al email para que la opción nunca salga en blanco.
const TicketsAgenteFilter = ({ usuarios, seleccionados, onChange }) => (
  <TicketsMultiFiltro
    etiqueta="Agente"
    ariaLabel="Filtrar por agente asignado"
    opciones={usuarios.map((u) => ({ id: u.id, label: u.nombre || u.email || String(u.id) }))}
    seleccionados={seleccionados}
    onChange={onChange}
  />
);

TicketsAgenteFilter.propTypes = {
  usuarios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nombre: PropTypes.string,
      email: PropTypes.string,
    }),
  ),
  seleccionados: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

TicketsAgenteFilter.defaultProps = {
  usuarios: [],
  seleccionados: [],
};

export default TicketsAgenteFilter;
